<template>
  <div id="map"></div>
</template>

<script>

import "leaflet/dist/leaflet.css"
import L from "leaflet/dist/leaflet.js"

export default {
  name: 'LeafletMap',
  props: {
    map:Object,
    color:String
  },
  data(){
    return{
      mapObj:null
    }
  },
  mounted(){
    this.createMap();
    this.addTileLayers();
    this.addLayers();
    this.setBorderColor();
  },
  updated(){
    this.removeLayers();
    this.addTileLayers();
    this.addLayers();
    this.setBorderColor();
  },
  methods:{
    getData(src){
        var path = require.context('../assets/', true, /\.json$/);
        return path("./" + src + ".json");
    },
    getImg(src){
        var path = require.context('../assets/', true, /\.png$/);
        return path("./" + src);
    },
    //calculate minimum value of expressed variable in a dataset
    calcMinValue(layer, expressed){
        //create empty array to store all data values
        var allValues = [];
        //loop through each feature 
        for(var feature of layer){
            var value = feature.properties[expressed];
            if (value){
              allValues.push(value);
            }
        }
        //get minimum value of array
        var minValue = Math.min(...allValues)

        return minValue;
    },
    //calculate proportional symbol radius 
    calcPropRadius(value, minValue, minRadius){
        var radius = 1.0083 * Math.pow(value/minValue,0.5715) * minRadius;

        return radius;
    },
    calcStyle(type, attribute, valueQ, valueC){
        var pageColor = this.color,
            output;

        if (type == "categorized"){
            attribute.forEach(function(cat){
                if (valueC == cat.value){
                  output = cat.output == "color" ? pageColor : cat.output;
                }
            })

            return output ? output : attribute[attribute.length - 1].output;
        }
        if (type == "graduated"){
            attribute.forEach(function(cat){
                if (valueQ > cat.value){
                  output = cat.output;
                }
            })

            return output ? output : attribute[attribute.length - 1].output;
        }
    },
    addLayers(){
      var self = this,
          layers = self.map.layers;
      if (layers){
          layers.forEach(function(layer){
              var src = self.getData(layer.src),
                  expressedQ = layer.expressedQ ? layer.expressedQ : null,
                  expressedC = layer.expressedC ? layer.expressedC : null,
                  tooltipField = layer.tooltipField ? layer.tooltipField : null,
                  tooltipFilter = layer.tooltipFilter ? layer.tooltipFilter : null,
                  options = {};
              //proportional symbol
              if (layer.type == "point"){     
                var min = self.calcMinValue(src.features, expressedQ);
                options = {
                    pointToLayer:function(feature, latlng){
                      var style = {
                        //if minradius is defined, caluclate proportional symbols
                        radius: layer.minRadius ? self.calcPropRadius(feature.properties[expressedQ], min, layer.minRadius) : Array.isArray(layer.radius) ? self.calcStyle("categorized", layer.radius, feature.properties[expressedQ], feature.properties[expressedC]): layer.radius,
                        fillColor:  Array.isArray(layer.fillColor) ? self.calcStyle(layer.fillType, layer.fillColor, feature.properties[expressedQ], feature.properties[expressedC]): layer.fillColor,
                        color: layer.color == "fill" ? self.calcStyle(layer.fillType, layer.fillColor, feature.properties[expressedQ], feature.properties[expressedC]): layer.color,
                        fillOpacity: layer.fillOpacity ? layer.fillOpacity : 0.7,
                        opacity: layer.opacity ? layer.fillOpacity : 0
                      }
                      
                      return L.circleMarker(latlng, style);
                    },
                    onEachFeature:function(feature, layer){
                      if (tooltipField){
                      if (feature.properties.classname == tooltipFilter){
                          layer.bindTooltip("<p class='tooltipText'>" + feature.properties[tooltipField] + "</p>",{
                            permanent:true,
                            className:'tooltip',
                            direction:'right',
                            offset:[0,-10]
                          })   
                        }
                      }
                    }
                }
              }
              if (layer.type == "polygon"){
                options = {
                    style:function(feature){
                      var style = {
                        //styles
                        fillColor:  Array.isArray(layer.fillColor) ? self.calcStyle(layer.fillType, layer.fillColor, feature.properties[expressedQ], feature.properties[expressedC]): layer.fillColor,
                        color: layer.color == "fill" ? self.calcStyle(layer.fillType, layer.fillColor, feature.properties[expressedQ], feature.properties[expressedC]): layer.color,
                        fillOpacity: layer.fillOpacity ? layer.fillOpacity : 0.7,
                        opacity: layer.opacity ? layer.fillOpacity : 0,
                        weight: layer.weight ? layer.weight :1
                      }
                      
                      return style;
                  }
                }
              }

              L.geoJSON(src,options).addTo(self.mapObj);
              
            })
          }
    },
    addTileLayers(){
      var self = this,
          basemap = self.map.basemap,
          opacity = basemap.opacity ? basemap.opacity : 1;

      L.tileLayer(basemap.url, {
        attribution: basemap.attribution,
        opacity: opacity
      }).addTo(self.mapObj);

      self.mapObj.panTo(self.map.center);
    },
    removeLayers(){
      var self = this,
          map = self.mapObj;

      if (self.mapObj){
        map.eachLayer(function(layer){
          map.removeLayer(layer);
        })
      }
    },
    createMap(){
        let self = this,
            mapData = self.map;

        this.mapObj = L.map('map',{
            center:mapData.center,
            zoom:mapData.zoom,
            maxZoom:mapData.maxZoom,
            minZoom:mapData.minZoom,
            scrollWheelZoom:false
        });

        /*var titleControl = L.Control.extend({
          options:{
            position:"bottomright"
          },
          onAdd: function(){
            var titleContainer = L.DomUtil.create("div","title-container"),
                title = mapData.title ? mapData.title : "Title";

            var img = "<img class='legend-img' src='" + self.getImg(mapData.legend) +"'></img>"

            titleContainer.insertAdjacentHTML("beforeend","<p>" + title +"</p>");
            titleContainer.insertAdjacentHTML("beforeend",img);

            return titleContainer;
          }
        });

        map.addControl(new titleControl());*/

    },
    setBorderColor(){
      var self = this;
      document.querySelector("#map").style.border = "2px solid" + self.color;
    }
  }
}
</script>

<style>
  #map{
    width:100%;
    height:100%;
  }
  .title-container{
    background:rgba(255,255,255,0.5);
    padding:10px;
    text-align:left;
  }
  .title-container > p{
    font-weight:bold;
    font-size:18px;
  }
  .title-container > img{
    width:50%;
  }
  .tooltip{
    background:none;
    border:none;
    box-shadow:none;
  }
  .tooltipText {
    font-weight:bold !important;
    font-size:20px !important;
  }
  .tooltip:before{
    display:none;
  }

</style>
